var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookBrand = function SvgFacebookBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-brand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v16H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C76BE",
    d: "M18.602 0H5.398A5.387 5.387 0 0 0 0 5.398v13.204A5.387 5.387 0 0 0 5.398 24h13.204A5.387 5.387 0 0 0 24 18.602V5.398A5.387 5.387 0 0 0 18.602 0Zm-3.239 7.723h-1.411c-.582 0-.914.25-.997.914v1.661h2.325l-.332 2.325h-1.993v5.897h-2.409v-5.897H8.555v-2.325h1.992V8.721c0-.332 0-.581.084-.913.083-.665.498-1.33 1.079-1.744.498-.333 1.08-.582 1.744-.582h1.245c.25 0 .416.084.665.084v2.159-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-brand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFacebookBrand;